/*
 * This file is auto-generated! Do not modify it directly.
 * To re-generate run 'make build'
 */
import { FLIPPED_ALIAS_KEYS } from "../../definitions/index.ts";

export const STANDARDIZED_TYPES = FLIPPED_ALIAS_KEYS["Standardized"];
export const EXPRESSION_TYPES = FLIPPED_ALIAS_KEYS["Expression"];
export const BINARY_TYPES = FLIPPED_ALIAS_KEYS["Binary"];
export const SCOPABLE_TYPES = FLIPPED_ALIAS_KEYS["Scopable"];
export const BLOCKPARENT_TYPES = FLIPPED_ALIAS_KEYS["BlockParent"];
export const BLOCK_TYPES = FLIPPED_ALIAS_KEYS["Block"];
export const STATEMENT_TYPES = FLIPPED_ALIAS_KEYS["Statement"];
export const TERMINATORLESS_TYPES = FLIPPED_ALIAS_KEYS["Terminatorless"];
export const COMPLETIONSTATEMENT_TYPES =
  FLIPPED_ALIAS_KEYS["CompletionStatement"];
export const CONDITIONAL_TYPES = FLIPPED_ALIAS_KEYS["Conditional"];
export const LOOP_TYPES = FLIPPED_ALIAS_KEYS["Loop"];
export const WHILE_TYPES = FLIPPED_ALIAS_KEYS["While"];
export const EXPRESSIONWRAPPER_TYPES = FLIPPED_ALIAS_KEYS["ExpressionWrapper"];
export const FOR_TYPES = FLIPPED_ALIAS_KEYS["For"];
export const FORXSTATEMENT_TYPES = FLIPPED_ALIAS_KEYS["ForXStatement"];
export const FUNCTION_TYPES = FLIPPED_ALIAS_KEYS["Function"];
export const FUNCTIONPARENT_TYPES = FLIPPED_ALIAS_KEYS["FunctionParent"];
export const PUREISH_TYPES = FLIPPED_ALIAS_KEYS["Pureish"];
export const DECLARATION_TYPES = FLIPPED_ALIAS_KEYS["Declaration"];
export const PATTERNLIKE_TYPES = FLIPPED_ALIAS_KEYS["PatternLike"];
export const LVAL_TYPES = FLIPPED_ALIAS_KEYS["LVal"];
export const TSENTITYNAME_TYPES = FLIPPED_ALIAS_KEYS["TSEntityName"];
export const LITERAL_TYPES = FLIPPED_ALIAS_KEYS["Literal"];
export const IMMUTABLE_TYPES = FLIPPED_ALIAS_KEYS["Immutable"];
export const USERWHITESPACABLE_TYPES = FLIPPED_ALIAS_KEYS["UserWhitespacable"];
export const METHOD_TYPES = FLIPPED_ALIAS_KEYS["Method"];
export const OBJECTMEMBER_TYPES = FLIPPED_ALIAS_KEYS["ObjectMember"];
export const PROPERTY_TYPES = FLIPPED_ALIAS_KEYS["Property"];
export const UNARYLIKE_TYPES = FLIPPED_ALIAS_KEYS["UnaryLike"];
export const PATTERN_TYPES = FLIPPED_ALIAS_KEYS["Pattern"];
export const CLASS_TYPES = FLIPPED_ALIAS_KEYS["Class"];
export const IMPORTOREXPORTDECLARATION_TYPES =
  FLIPPED_ALIAS_KEYS["ImportOrExportDeclaration"];
export const EXPORTDECLARATION_TYPES = FLIPPED_ALIAS_KEYS["ExportDeclaration"];
export const MODULESPECIFIER_TYPES = FLIPPED_ALIAS_KEYS["ModuleSpecifier"];
export const ACCESSOR_TYPES = FLIPPED_ALIAS_KEYS["Accessor"];
export const PRIVATE_TYPES = FLIPPED_ALIAS_KEYS["Private"];
export const FLOW_TYPES = FLIPPED_ALIAS_KEYS["Flow"];
export const FLOWTYPE_TYPES = FLIPPED_ALIAS_KEYS["FlowType"];
export const FLOWBASEANNOTATION_TYPES =
  FLIPPED_ALIAS_KEYS["FlowBaseAnnotation"];
export const FLOWDECLARATION_TYPES = FLIPPED_ALIAS_KEYS["FlowDeclaration"];
export const FLOWPREDICATE_TYPES = FLIPPED_ALIAS_KEYS["FlowPredicate"];
export const ENUMBODY_TYPES = FLIPPED_ALIAS_KEYS["EnumBody"];
export const ENUMMEMBER_TYPES = FLIPPED_ALIAS_KEYS["EnumMember"];
export const JSX_TYPES = FLIPPED_ALIAS_KEYS["JSX"];
export const MISCELLANEOUS_TYPES = FLIPPED_ALIAS_KEYS["Miscellaneous"];
export const TYPESCRIPT_TYPES = FLIPPED_ALIAS_KEYS["TypeScript"];
export const TSTYPEELEMENT_TYPES = FLIPPED_ALIAS_KEYS["TSTypeElement"];
export const TSTYPE_TYPES = FLIPPED_ALIAS_KEYS["TSType"];
export const TSBASETYPE_TYPES = FLIPPED_ALIAS_KEYS["TSBaseType"];
/**
 * @deprecated migrate to IMPORTOREXPORTDECLARATION_TYPES.
 */
export const MODULEDECLARATION_TYPES = IMPORTOREXPORTDECLARATION_TYPES;
